module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_starlight.24d8906f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_starlight.png
// module id = 2114
// module chunks = 0